import { Stack } from "@mui/material";
import AgapeIcon from "../../../../common/icons/AgapeIcon";

import { Typography, useMediaQuery } from "@material-ui/core";
import React from "react";
import { useTheme } from "@material-ui/core/styles";

const AmoumtComponent = ({ setValue }) => {
  const [amount, setAmount] = React.useState(0);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const handleClick = (index, label) => {
    setAmount(index);
    setValue(label);
  };
  const Amount = [
    {
      label: 5,
      icon: (
        <AgapeIcon
          icon="logo-euro"
          size="15px"
          color="rgba(21, 52, 42, 0.72)"
        />
      ),
    },
    {
      label: 20,
      icon: (
        <AgapeIcon
          icon="logo-euro"
          size="15px"
          color="rgba(21, 52, 42, 0.72)"
        />
      ),
    },
    {
      label: 50,
      icon: (
        <AgapeIcon
          icon="logo-euro"
          size="15px"
          color="rgba(21, 52, 42, 0.72)"
        />
      ),
    },
    {
      label: 100,
      icon: (
        <AgapeIcon
          icon="logo-euro"
          size="15px"
          color="rgba(21, 52, 42, 0.72)"
        />
      ),
    },
    {
      label: 200,
      icon: (
        <AgapeIcon
          icon="logo-euro"
          size="15px"
          color="rgba(21, 52, 42, 0.72)"
        />
      ),
    },
  ];

  const AmountBox = Amount.map((item, index) => (
    <div
      key={index}
      onClick={() => handleClick(index, item.label)}
      style={{
        width: "90px",
        height: "40px",
        cursor: "pointer",
        marginTop: isMobile ? "10px" : 0,
        marginBottom: isMobile ? "10px" : 0,
      }}
    >
      <Stack
        display={"flex"}
        alignItems={"center"}
        justifyContent={"space-between"}
        style={{
          width: "90px",
          height: "40px",
          backgroundColor: amount === index ? "#009693" : "transparent",
        }}
        flexDirection={"row"}
        border={"1px solid #B6B3B3"}
        borderRadius={"30px"}
        marginRight={isMobile ? 0 : "10px"}
        paddingX={"5px"}
        marginBottom={"10px"}
      >
        <Typography
          style={{
            color: amount === index ? "#FFFFFF" : "#B6B3B3",
            fontFamily: "Vazir-bold",
          }}
        >
          {item.label}
        </Typography>
        {amount === index ? (
          <AgapeIcon icon="logo-euro" size="15px" color="#FFFFFF" />
        ) : (
          item.icon
        )}
      </Stack>
    </div>
  ));
  return (
    <Stack
      display={"flex"}
      //   alignItems={"center"}
      justifyContent={"space-around"}
      flexDirection={"row"}
      flexWrap={isMobile ? "wrap" : "nowrap"}
      style={{ width: isMobile ? "100%" : "69%" }}
    >
      {AmountBox}
    </Stack>
  );
};

export default AmoumtComponent;
